<template>
  <div class="top-margin" v-if="params.data.length > 1">
    Vrijeme provedeno na lokaciji
    <b> {{ title }}:</b>
    <!-- Table -->
    <div class="columns is-centered">
      <div class="column is-half">
        <div>
          <vue-table-dynamic :params="params"></vue-table-dynamic>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueTableDynamic from "vue-table-dynamic-sum";

import { colors } from "../../_helpers/colors";

import { getDateFromTicks, maskIfEquealsValue } from "../../_helpers/arrangers";

export default {
  name: "BrakeListingTable",

  components: {
    VueTableDynamic,
  },

  props: {
    title: String,
    data: Array,
  },

  data() {
    return {
      params: {
        data: [["R.br", "Ulaz", "Izlaz", "Provedeno vrijeme"]],
        header: "row",
        enableSearch: false,
        border: true,
        stripe: true,
        wordWrap: "break-word",
        whiteSpace: "normal",
        highlight: { row: [-1] },
        highlightedColor: colors[6],
        columnWidth: [
          { column: 0, width: "9%" },
          { column: 1, width: "30%" },
          { column: 2, width: "30%" },
        ],
        sumSecretPhrase: "Σ",
        sumColumns: [{ column: 3, type: "time" }],
      },
    };
  },

  mounted() {
    // this.arrangeData();
    let totalValue = [0];

    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].isLogicallyClosed === true) {
        //   this.params.highlightedColor = colors[6];
        // } else {
        //   this.params.highlightedColor = colors[5];
        // }
        this.params.data.push([
          i + 1,
          this.data[i].departureTime.split("T")[1],
          this.data[i].arrivalTime.split("T")[1],
          maskIfEquealsValue(
            getDateFromTicks(this.data[i].duration),
            "00:00:00"
          ),
        ]);

        totalValue[0] += this.data[i].duration;
      }
    }

    if (this.data.length !== 0) {
      // add sum row
      this.params.data.push([
        "Σ",
        "",
        "",
        maskIfEquealsValue(getDateFromTicks(totalValue[0]), "00:00:00"),
      ]);
    }
  },
};
</script>

<style scoped>
.top-margin {
  margin-top: 10px; /* Adjust this value as needed */
}
</style>